<template>
  <v-app>
    <v-main>
      <v-container class="pa-0">
        <v-row class="d-print-none">
          <v-col class="d-flex">
            <v-btn @click="back">
              <v-icon>mdi-undo-variant</v-icon>
            </v-btn>
            <v-btn
              color="warning"
              @click="print"
            >
              <v-icon>mdi-printer</v-icon>
            </v-btn>
            <v-spacer />
            <p class="clearStyleTip">
              <strong>Tip : </strong> Press <code>Ctrl + Shift + R</code> to
              clear or reset print page layout cache.
            </p>
          </v-col>
        </v-row>

        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>
<script type="text/javascript">
export default {
  methods: {
    print() {
      window.print();
    },
    back() {
      this.$router.back();
    },
  },
};
</script>
<style type="text/css">
.clearStyleTip {
  font-size: 11px;
}
</style>
